export default __webpack_public_path__ + "static/media/personalize.33005f3d.png";